/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import React, { useState } from 'react'

interface EditableFieldProps {
  value: string
  isDisabled?: boolean
  children: React.ReactNode
  onChange?: () => void
}

export function EditableField({ value, isDisabled = false, children, onChange }: EditableFieldProps) {
  const [isEditing, setIsEditing] = useState(false)

  const handleClick = () => {
    if (!isDisabled) {
      setIsEditing(true)
      onChange?.()
    }
  }

  const handleBlur = () => {
    setIsEditing(false)
  }

  if (isEditing) {
    return <div className="editable-field editing">{children}</div>
  }

  return (
    <div className="editable-field" onClick={handleClick} style={{ cursor: isDisabled ? 'default' : 'pointer' }}>
      <span className="fake_input">{value}</span>
    </div>
  )
}

export default EditableField
